// src/utils/authHelpers.js

export const getPolicyKey = (u) => `erp_policy_accepted_${u.businessId || "global"}_${u.email || "user"}`;

export const getDefaultTabForUser = (u) => {
  const ff = u.features || {
    hasOrders: true,
    hasRawMaterials: true,
    hasWalkinSales: true,
    hasAmbassadors: true,
    hasProfitAlloc: true,
    hasAssets: true,
  };
  return (
    u.role === "manager" ? "dashboard" :
    u.role === "ambassador" ? "ambdash" :
    u.role === "sales" ? (ff.hasOrders ? "orders" : ff.hasWalkinSales ? "newsale" : "dashboard") :
    u.role === "cashier" ? (ff.hasOrders ? "payments" : ff.hasWalkinSales ? "newsale" : "expenses") :
    "dashboard"
  );
};